import React, { Component } from 'react';
import './Bracket.scss';

// https://api-fcb.pulselive.com/genericsport/compseasons/20152/fixtures
// https://api-fcb.pulselive.com/genericsport/compseasons/30535/fixtures

type Props = {
  data: any;
  esport: string;
};

export default class Bracket extends Component<Props> {
  parseBracket(data: any) {
    return {
      phases: data.phases.filter((phase: any) => phase.type !== 3).map((phase: any) => {
        return {
          versus: phase.days.map((day: any) => {
            return day.matches.map((match: any) => {
              return {
                ...match,
                homeTeam: match.homeTeam ? match.homeTeam.name : null,
                awayTeam: match.awayTeam ? match.awayTeam.name : null,
              };
            });
          }),
        };
      })
    }
  }

  render() {
    const { data, esport } = this.props;

    const bracket = this.parseBracket(data);

    const rounds = bracket.phases.length;
    const columns = rounds * 2 + 1;
    const rows = bracket.phases.length - 1;

    return (
      <div
        className="bracket"
        style={{
          '--rounds': bracket.phases.length,
          gridTemplateColumns: `repeat(${columns}, 1fr)`,
          gridTemplateRows: `repeat(${rows}, 1fr)`,
        } as React.CSSProperties}
      >
        {new Array(bracket.phases.length * 2 - 1).fill(null).map((_, i) => {
          const matchesPerRound = 2 ** Math.abs(i - (bracket.phases.length - 1));
          const direction = bracket.phases.length - 1;
          const round = bracket.phases[Math.min(i, (bracket.phases.length * 2 - 1) - 1 - i)];
          const teams = Object.values(
            round?.versus?.flat().reduce((acc, match) => {
              const teams = [
                {
                  id: match.homeTeamId,
                  name: match.homeTeamName,
                },
                {
                  id: match.awayTeamId,
                  name: match.awayTeamName,
                },
              ].sort((a, b) => b.name.localeCompare(a.name));

              const key = `${teams[0].id}-${teams[1].id}`;

              if (!acc[key]) {
                acc[key] = {
                  teams,
                  matches: [],
                  wins: {
                    [match.homeTeamId]: 0,
                    [match.awayTeamId]: 0,
                  },
                };
              }
              if ((match.homeScore > match.awayScore) || (match.homePenalties > match.awayPenatlies)) {
                acc[key].wins[match.homeTeamId]++;
              } else if ((match.awayScore > match.homeScore) || (match.awayPenatlies > match.homePenalties)) {
                acc[key].wins[match.awayTeamId]++;
              }
              acc[key].matches.push(match);

              return acc;
            }, {} as Record<string, any>)
          ).map((duel: any) => {
            const [teamA, teamB] = duel.teams;

            return {
              teams: duel.teams,
              matches: duel.matches,
              winnerId:
                duel.wins[teamA.id] > duel.wins[teamB.id]
                  ? teamA.id
                  : duel.wins[teamB.id] > duel.wins[teamA.id]
                    ? teamB.id
                    : null,
            };
          });
          return (
            <div className={`column ${i <= direction && 'left'} ${i >= direction && 'right'}`} key={i}>
              {new Array(Math.max(1, matchesPerRound / 2 | 0)).fill(null).map((_, j) => {
                const { winnerId } = teams[i < direction || matchesPerRound === 1 ? j : j + (matchesPerRound / 2)];
                const team = teams[i < direction || matchesPerRound === 1 ? j : j + (matchesPerRound / 2)].teams;
                return (
                  <>
                    <div className="match" key={`${i}-${j}-1`}>
                      <img className={team[0].id !== winnerId && 'loser'} src={`/assets/fcb/${esport}/${team[0].id}.png`} alt="" />
                      {matchesPerRound === 1 && <img className={team[1].id !== winnerId && 'loser'} src={`/assets/fcb/${esport}/${team[1].id}.png`} alt="" />}
                    </div>
                    {matchesPerRound !== 1 && <div className="match" key={`${i}-${j}-2`}>
                      <img className={team[1].id !== winnerId && 'loser'} src={`/assets/fcb/${esport}/${team[1].id}.png`} alt="" />
                    </div>}
                  </>
                );
              })}
              <div className="lines">
                {new Array(matchesPerRound === 1 ? 0 : matchesPerRound / 2).fill(null).map((_, j) => {
                  const h = 100 / matchesPerRound;
                  return (
                    <span className="line" style={{
                      height: `calc(${h}% + 4px)`,
                    } as React.CSSProperties} key={`${i}-${j}-line`}></span>
                  );
                })}
              </div>
            </div>
          )
        })}
      </div>
    );
  }
}